export default __webpack_public_path__ + "static/media/ProjectBackground.d7928bde.jpg";